import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';

import { Area } from '../../models/area';
import { Mensagem } from '../../models/mensagem';

@Injectable()
export class AreaLocalProvider {

    private _$areas: BehaviorSubject<Area[]>;
    private readonly limiteDeMensagens = 50;
    
    constructor() {
        this._$areas = new BehaviorSubject<Area[]>(this.getAreas() || []);
    }

    public get $areas() {
        return this._$areas.asObservable();
    }

    public updateArea(area: Area): void {
        const areas = this.getAreas();
        for (let i = 0, len = areas.length; i < len; i++) {
            if (areas[i].idArea === area.idArea) {
                areas[i] = area
                break;
            }
        }
        this.setAreas(areas);
    }

    public setAreas(areas: Area[]): void {
        localStorage.setItem('areas', JSON.stringify(areas));
        this._$areas.next(areas);
    }

    public marcarMensagensLidas(idArea: number, idUsuario: number): void {
        const area = this.getArea(idArea);
        if (area && area.mensagens) {
            for (const mensagem of area.mensagens) {
                if (mensagem.idUsuarioOrigem !== idUsuario) {
                    mensagem.statusMensagemLida = true;
                }
            }
            this.updateArea(area);
        }
    }

    public setMensagensArea(idArea: number, mensagens: Mensagem[]): void {
        const area = this.getArea(idArea);
        if (area) {
            area.mensagens = mensagens;
            this.updateArea(area);
        }
    }

    public adicionarNovaMensagem(idArea: number, mensagem: Mensagem) {
        let area = this.getArea(idArea);
        if (!area.mensagens) {
            area.mensagens = [];
        }
        area.mensagens.push(mensagem);
        this.updateArea(area);
    }

    public atualizarMensagem(idArea: number, m: Mensagem): void {
        const area = this.getArea(idArea);
        if (area) {
            // a pesquisa é invertida pois é provavel que a mensagem esteja no fim
            for (let i = area.mensagens.length - 1; i >= 0; i--) {
                const mensagem = area.mensagens[i];
                if (mensagem.idEnvio && mensagem.idEnvio === m.idEnvio) {
                    area.mensagens[i] = m
                    break;
                }
            }
            this.updateArea(area);
        }
    }

    public removerMensagensAcimaDoLimite(idArea: number): void {
        const area = this.getArea(idArea);
        if(area && area.mensagens && area.mensagens.length > this.limiteDeMensagens) {
            area.mensagens = area.mensagens.slice(-this.limiteDeMensagens);
            this.updateArea(area);
        }
    }

    public marcarMensagemRecebida(idArea: number, idEnvio: number): void {
        const area = this.getArea(idArea);
        if (area) {
            for (let i = area.mensagens.length - 1; i >= 0; i--) {
                const mensagem = area.mensagens[i];
                if (mensagem.idEnvio && mensagem.idEnvio === idEnvio) {
                    mensagem.statusMensagemRecebida = true;
                    break;
                }
            }
            this.updateArea(area);
        }
    }

    public getMensagensComRecebimentoPendente(): Mensagem[] {
        const areas = this.getAreas();
        if (areas) {
            let mensagensComNotificacaoDeRecebimentoPendente = []
            for (const area of areas) {
                for (const mensagem of area.mensagens) {
                    if (!mensagem.statusMensagemRecebida) {
                        mensagensComNotificacaoDeRecebimentoPendente.push(mensagem);
                    }
                }
            }
            return mensagensComNotificacaoDeRecebimentoPendente;
        }
    }

    public atualizarMensagemEnviada(idArea: number, idEnvioLocal: number, idEnvio: number): void {
        const area = this.getArea(idArea);
        if (area && area.mensagens) {
            // a pesquisa é invertida pois é provavel que a mensagem esteja no fim
            for (let i = area.mensagens.length - 1; i >= 0; i--) {
                const mensagem = area.mensagens[i];
                if (mensagem.idEnvio && mensagem.idEnvio === idEnvioLocal) {
                    mensagem.idEnvio = idEnvio;
                    mensagem.pendente = false;
                    break;
                }
            }
            this.updateArea(area);
        }
    }

    public setAreasUsuarios(usuarios: any[]): void {
        this.setAreas(usuarios[0].Areas);
    }

    public getArea(idArea): Area | undefined {
        const areas = this.getAreas();
        if (areas) {
            return this.getAreas().find(a => a.idArea == idArea);
        }
    }

    public getAreas(): Area[] | undefined {
        return JSON.parse(localStorage.getItem('areas'));
    }

}



// WEBPACK FOOTER //
// ./src/providers/area-local/area-local.ts